<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="structure" xml:lang="en-US"> </p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-2">Making Vegan<br/>Meat</span></p>
<p class="Basic-Paragraph ParaOverride-3"><span class="CharOverride-3">The Plant-Based<br/>Food Science<br/>cookbook</span></p>
<p class="Basic-Paragraph ParaOverride-4"><img alt="" class="_idGenObjectAttribute-1" src="image/Artwork_250.png"/></p>
<p class="Basic-Paragraph ParaOverride-5"><img alt="" class="_idGenObjectAttribute-2" src="image/Mango_Publishing_Group.png"/></p>
<p class="Basic-Paragraph ParaOverride-6"><span class="CharOverride-4">Coral Gables</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// MakingVeganMeat-1.vue?8b15dfd8